export default "__VITE_ASSET__DKYJKOoo__"